import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { StoreState } from 'store'
import { Heading } from '@chakra-ui/react'
import { LeadGroupUser } from '@homevest/types/rental-applications'
import { capabilities } from '@homevest/utils'

import BackgroundCheckReport from './UserBackgroundCheckDetails'

import { hasCapability } from 'lib/admin-perms'
const { USER_DOC_VIEWER } = capabilities.CAPABILITY_TYPES

function UserBackgroundCheckInfo({ leadGroupUser }: { leadGroupUser: LeadGroupUser }) {
  const { users } = leadGroupUser

  const creditReport = users.credit_report ?? null
  const criminalReport = users.criminal_report ?? null
  const evictionReport = users.eviction_report ?? null

  const isDocViewer = useSelector((store: StoreState) =>
    hasCapability(store.admin, USER_DOC_VIEWER)
  )

  if (!isDocViewer) {
    return null
  }

  return (
    <div className='mb-3'>
      <div>
        <Heading size='md' marginTop={3} as='h3'>
          Background Check Info
        </Heading>
      </div>
      <BackgroundCheckReport
        report={creditReport}
        userId={leadGroupUser.users.id}
        reportType='credit_reports'
      />
      <BackgroundCheckReport
        report={criminalReport}
        userId={leadGroupUser.users.id}
        reportType='criminal_reports'
      />
      <BackgroundCheckReport
        report={evictionReport}
        userId={leadGroupUser.users.id}
        reportType='eviction_reports'
      />
    </div>
  )
}

UserBackgroundCheckInfo.propTypes = {
  leadGroupUser: PropTypes.object
}

export default memo(UserBackgroundCheckInfo)
